import DataPointReportBuilder from "@/features/datapoints/components/report/DataPointReportBuilder"

export default function NewReport() {
  return <DataPointReportBuilder />
}
